exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topBorder[data-v-5e51d980]{border-top:2px solid #000;padding:20px 0}.media[data-v-5e51d980]{border-bottom:2px solid gray;margin-bottom:10px}.media .li[data-v-5e51d980]{padding-left:0}.media h5[data-v-5e51d980]{font-weight:700;margin-top:-4px!important}.media b[data-v-5e51d980]{font-size:small}.media p[data-v-5e51d980]{font-size:small;font-weight:500}.media img[data-v-5e51d980]{margin-bottom:10px;padding-left:0;max-width:150px;width:auto!important}@media (max-width:576px){.media[data-v-5e51d980]{display:block}.media img[data-v-5e51d980]{max-width:50%;max-height:260px;width:100%}.media-body[data-v-5e51d980]{padding:10px 0;flex:1 0 100%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5e51d980","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/overall_layouts/media-items.vue
// module id = 585
// module chunks = 0